var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleOutlinePlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#circle_outline_plus_svg__clip0_1_16949)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.001 5.25a.752.752 0 00-.75.75v2.25h-2.25a.752.752 0 00-.75.75c0 .412.337.75.75.75h2.25V12c0 .412.337.75.75.75.412 0 .75-.338.75-.75V9.75h2.25c.413 0 .75-.338.75-.75a.752.752 0 00-.75-.75h-2.25V6a.752.752 0 00-.75-.75zm0-3.75c-4.14 0-7.5 3.36-7.5 7.5 0 4.14 3.36 7.5 7.5 7.5 4.14 0 7.5-3.36 7.5-7.5 0-4.14-3.36-7.5-7.5-7.5zm0 13.5c-3.308 0-6-2.693-6-6 0-3.308 2.692-6 6-6s6 2.692 6 6c0 3.307-2.692 6-6 6z",
    fill: "#58B847"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "circle_outline_plus_svg__clip0_1_16949"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.001)",
    d: "M0 0h18v18H0z"
  })))));
}
export default SvgCircleOutlinePlus;